import {SupportedLanguagesDto} from "../models/interfaces/dtos/supportedLanguages.dto.interace.ts";
import http from "./httpService.ts";

export const supportedLanguages = async (): Promise<SupportedLanguagesDto[]> => {
  try {
    const response = await http.get("/api/v1/supported-languages");
    return response.data as SupportedLanguagesDto[];
  } catch (err) {
    console.error("Error fetching supported languages", err);
    throw err;
  }
}